import {useGetPharmacy, useGetPharmacyActivities} from '@/modules/pharmacies/api'
import {EventLog, Pharmacy} from '@cypro/engine/schema'
import {createContext, PropsWithChildren, useContext} from 'react'

interface State {
  pharmacy: Pharmacy
  activities: EventLog[] | undefined
}

interface Props extends PropsWithChildren {
  pharmacy: Pharmacy
}

const PharmacyContext = createContext<State>({} as State)

export function PharmacyProvider({children, pharmacy: initialPharmacy}: Props) {
  const [pharmacy] = useGetPharmacy(initialPharmacy?.id)
  const [activities] = useGetPharmacyActivities(initialPharmacy?.id)

  return (
    <PharmacyContext.Provider value={{pharmacy: pharmacy || initialPharmacy, activities}}>
      {children}
    </PharmacyContext.Provider>
  )
}

export function usePharmacyContext() {
  return useContext(PharmacyContext)
}
